import React from 'react';
import { ChevronDown, ChevronUp, Search } from 'lucide-react';

const FAQList = ({ faqs, openIndex, toggleAccordion, language }) => {
  if (faqs.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <Search className="w-10 h-10 text-gray-400" />
        </div>
        <p className="text-gray-500 text-lg">
          {language === 'english' 
            ? 'No FAQs found matching your search.'
            : 'നിങ്ങളുടെ തിരയലുമായി പൊരുത്തപ്പെടുന്ന FAQ-കൾ കണ്ടെത്തിയില്ല.'
          }
        </p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {faqs.map((faq, index) => {
        const IconComponent = faq.icon;
        const isOpen = openIndex === index;
        
        return (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-all duration-300"
          >
            <button
              onClick={() => toggleAccordion(index)}
              className="w-full px-4 sm:px-5 md:px-8 py-4 sm:py-6 text-left flex items-center justify-between hover:bg-gray-50 transition-colors duration-200"
            >
              <div className="flex items-start gap-4 flex-1 mr-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <h3 className="text-base sm:text-lg font-medium text-gray-900 leading-tight">
                      {faq.question}
                    </h3>
                  </div>
                </div>
              </div>
              <div className="flex-shrink-0 w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                {isOpen ? (
                  <ChevronUp className="w-5 h-5 text-gray-600" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-600" />
                )}
              </div>
            </button>
            
            {isOpen && (
              <div className="px-3 pb-6">
                <div className="">
                  <div className="bg-gray-50 rounded-xl p-2 sm:p-6 text-gray-700 leading-relaxed">
                    {faq.answer}
                  </div>
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQList;